import { PageTypes } from '@features/page/page.config';
import { GenericPageComponent } from '@features/page/page.models';

export const getLazyPageComponent: (template: string) => Promise<GenericPageComponent<any>> = async (
    template: string
) => {
    switch (template) {
        case PageTypes.RootPage:
            return await import('@features/page/root-page/root-page.component').then(m => m.RootPageComponent);
        case PageTypes.StandardPage:
            return await import('@features/page/standard-page/standard-page.component').then(
                m => m.StandardPageComponent
            );
        case PageTypes.ErrorPage:
            return await import('@features/page/error-page/error-page.component').then(m => m.ErrorPageComponent);
        case PageTypes.ArticlePage:
            return await import('@features/page/article-page/article-page.component').then(m => m.ArticlePageComponent);
        case PageTypes.BrandPage:
            return await import('@features/page/brand-page/brand-page.component').then(m => m.BrandPageComponent);
        case PageTypes.CheckoutPage:
            return await import('@features/page/checkout-page/checkout-page.component').then(
                m => m.CheckoutPageComponent
            );
        case PageTypes.OrderConfirmationPage:
            return await import('@features/page/order-confirmation-page/order-confirmation-page.component').then(
                m => m.OrderConfirmationPageComponent
            );
        case PageTypes.BasketPage:
            return await import('@features/page/basket-page/basket-page.component').then(m => m.BasketPageComponent);

        case PageTypes.Recipe:
        case PageTypes.RecipePage:
            return await import('@features/page/recipe-page/recipe-page.component').then(m => m.RecipePageComponent);

        case PageTypes.StoresPage:
            return await import('@features/page/stores-overview-page/stores-overview-page.component').then(
                m => m.StoresOverviewPageComponent
            );
        case PageTypes.StorePage:
            return await import('@features/page/store-page/store-page.component').then(m => m.StorePageComponent);
        case PageTypes.ProductFilterPage:
            return await import('@features/page/product-filter-page/product-filter-page.component').then(
                m => m.ProductFilterPageComponent
            );
        case PageTypes.ProductDetailPage:
            return await import('@features/page/product-detail-page/product-detail-page.component').then(
                m => m.ProductDetailPageComponent
            );
        case PageTypes.ClubPage:
            return await import('@features/page/club-page/club-page.component').then(m => m.ClubPageComponent);
        case PageTypes.ClubStandardPage:
            return await import('@features/page/club-standard-page/club-standard-page.component').then(
                m => m.ClubStandardPageComponent
            );
        case PageTypes.ClubPersonalInfoPage:
            return await import('@features/page/club-personal-info-page/club-personal-info-page.component').then(
                m => m.ClubPersonalInfoPageComponent
            );
        case PageTypes.SearchPage:
            return await import('@features/page/search-page/search-page.component').then(m => m.SearchPageComponent);
        case PageTypes.AviouPage:
            return await import('@features/page/aviou-page/aviou-page.component').then();
        default:
            return null;
    }
};
